import { Lease, PropertyRevenue, CalculationMeta, HeadlineToEffectiveMeta, CostRevenue } from "../../types";
import { IncomeValuationProcess } from "../../types/valuation-process";

export function setHeadlineToEffectiveMeta(
  process: IncomeValuationProcess, 
  {uuid, kind, meta}: {
    uuid: string, 
    kind: 'lease' | 'property-revenue'
    meta: HeadlineToEffectiveMeta
  }
): IncomeValuationProcess {
  return {
    ...process,
    data: {
      ...process.data,
      leases: kind === 'lease' ? updateLeaseMeta(process.data.leases, uuid, meta) : process.data.leases,
      propertyRevenues: kind === 'property-revenue' ? updatePropertyRevenues(process.data.propertyRevenues, uuid, meta) : process.data.propertyRevenues
    }
  }
}

function updateLeaseMeta(leases: Lease[], uid: string, meta: HeadlineToEffectiveMeta): Lease[] {
  return leases.map(item => {
    if (item.uid === uid) {
      return {
        ...item,
        headlineToEffectiveMeta: meta
      }
    }
    return item
  })
}
function updatePropertyRevenues(revenues: PropertyRevenue[], uid: string, meta: HeadlineToEffectiveMeta): PropertyRevenue[] {
  return revenues.map(item => {
    if (item.uid === uid) {
      return {
        ...item,
        headlineToEffectiveMeta: meta
      }
    }
    return item
  })
}